export const menuItems = [
	{ uuid: 'rides-uuid', title: 'Rides list', link: '/', prefix: '' },
	{
		uuid: 'work-assignments-uuid',
		title: 'Work Assignments',
		link: '/work-assignments',
		prefix: 'work-assignments',
	},
	{
		uuid: 'crew-timeline-uuid',
		title: 'Crew Timeline',
		link: '/crew-timeline',
		prefix: 'crew-timeline',
	},
	{
		uuid: 'crew-management-uuid',
		title: 'Crew Management',
		link: '/crew-management',
		prefix: 'crew-management',
	},
];
export const DARK_MODE_LABEL = 'Dark mode';
export const CURRENTLY_DEPLOYED_BRANCH = 'Currently deployed branch:';
